export const modalTableConfig = {
  title: '波段详情',
  propList: [
    {
      prop: 'dateRange',
      label: '波段日期',
      minWidth: '120',
      slotName: 'dateRange'
    },
    {
      prop: 'change',
      label: '波段涨跌额',
      minWidth: '120',
      sortable: true,
      slotName: 'change'
    },
    {
      prop: 'zf',
      label: '波段涨跌幅',
      minWidth: '120',
      sortable: true,
      slotName: 'zf'
    },
    {
      prop: 'change0',
      label: '荐股至波段结束涨跌额',
      minWidth: '120',
      sortable: true,
      slotName: 'change0'
    },
    {
      prop: 'zf0',
      label: '荐股至波段结束涨跌幅',
      minWidth: '120',
      sortable: true,
      slotName: 'zf0'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
